import scroll from 'core/scroll';
import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
import store from 'store';
export default class Overlay extends Component {
    bindEvents(add) {
        const method = bindMethod(add);
        store.overlay.toggleListener(add, (value) => this.onOverlayChange(value));
        store.overlayStrength.toggleListener(add, (value) => this.onOverlayStrengthChange(value));
        this.el[method]('click', this.onClick);
    }
    onOverlayChange(value) {
        this.el.classList.toggle('visible', !!value);
    }
    onOverlayStrengthChange(value) {
        if (this.el.classList.contains('visible'))
            this.el.className = `overlay overlay__${value} visible`;
        else
            this.el.className = `overlay overlay__${value}`;
    }
    onClick = async () => {
        this.emit('overlay:click');
        if (store.persistantOverlay.get())
            return;
        store.search.set(null);
        store.panel.set(null);
        store.drawer.set(null);
        scroll.unlock(true);
    };
}
